import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';

export default class HasAbilityHelper extends Helper {
  @service declare abilities: AbilitiesService;

  compute([abilityName]: string[]) {
    return this.abilities.hasAbility(abilityName!);
  }
}

declare module '@ember/helper' {
  interface Registry {
    'has-ability': HasAbilityHelper;
  }
}
